import { useMutation, useQueryClient } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import { deleteSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import OpeningTime, { OPENING_TIME } from "../../OpeningTimes/OpeningTime";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useDeleteSupplierOpeningTime = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (openingTime: OpeningTime) =>
      axios.delete<number>(openingTimesUrls.openingTimeWithId(openingTime.Id)),
    onSuccess: async (_: AxiosResponse<number>, variables: OpeningTime) => {
      /// ToDo: Change invalidation to openingTimesForSupplierWithIdQueryKey and behaviour
      await queryClient.invalidateQueries(namedQueryKeyWithId("suppliers", variables.ParentId));
      toast.success(deleteSuccessMessage(variables.ParentId, `${OPENING_TIME} for Supplier`));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
